import React from "react";

const ACTIVE_PORTFOLIO_STORAGE_KEY = "investments.activePortfolioId";

export function useActivePortfolioSelection(portfolioIDs: number[]): [number | null, (value: number | null) => void] {
  const [selectedPortfolioID, setSelectedPortfolioID] = React.useState<number | null>(() => {
    if (typeof window === "undefined") {
      return null;
    }
    const raw = window.localStorage.getItem(ACTIVE_PORTFOLIO_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : null;
  });

  React.useEffect(() => {
    if (portfolioIDs.length === 0) {
      setSelectedPortfolioID(null);
      if (typeof window !== "undefined") {
        window.localStorage.removeItem(ACTIVE_PORTFOLIO_STORAGE_KEY);
      }
      return;
    }
    if (selectedPortfolioID != null && portfolioIDs.includes(selectedPortfolioID)) {
      return;
    }
    setSelectedPortfolioID(portfolioIDs[0]);
  }, [portfolioIDs, selectedPortfolioID]);

  React.useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    if (selectedPortfolioID == null) {
      window.localStorage.removeItem(ACTIVE_PORTFOLIO_STORAGE_KEY);
      return;
    }
    window.localStorage.setItem(ACTIVE_PORTFOLIO_STORAGE_KEY, String(selectedPortfolioID));
  }, [selectedPortfolioID]);

  return [selectedPortfolioID, setSelectedPortfolioID];
}
